var map = {
	"./canvas.png": 43711,
	"./flowchart.png": 17395,
	"./list.png": 25835,
	"./mindmap.png": 70193,
	"./pest.png": 8819,
	"./portrait.png": 85970,
	"./story.png": 16860,
	"./swot.png": 78248,
	"./table.png": 8759,
	"./timeline.png": 48442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21200;